export const environment = {
  production: false,
  apiURL    : 'https://realplaza-cusco.mzzo.com/api/',
  // apiURL    : 'http://localhost:8000/api/',
  edificio  : 158,
  totem     : 319,
  canal     : 2,
  idioma    : 'Esp',
  timereload : 60,
  tiendaimagen : false,
  idEst : [6376], /* IDs de estacionamientos */
  colorEst : ['Naranja'], /* colores estacionamientos*/

  codCine: '0', /* id de Cine */
  patioDeComida: 997, /* id patio de comida, en caso de no haber usar 0 */
  zonaGourmet: 998, /* id zona gourmet, en caso de no haber usar 0 */

  orientacionHor : [106, 0], /* [Norte, Sur] */
  orientacionVer : [0, 0], /* [Oeste, Este] */
  tipoTransporte : {pie: 65, alternativo: 66}
};
